<script setup lang="ts">
import UiStatusSDanger from '@@/lib/ui-toolkit/components/status/UiStatusSDanger.vue';
import UiStatusSWarning from '@@/lib/ui-toolkit/components/status/UiStatusSWarning.vue';

defineProps<{
  type?: 'danger' | 'warning' | 'info';
  title?: string;
}>();
</script>

<template>
  <div class="message" :class="[type && `is-type-${type}`]">
    <div v-if="title" class="message-title heading-6">
      <UiStatusSDanger v-if="type === 'danger'" />
      <UiStatusSWarning v-else-if="type === 'warning'" />
      {{ title }}
    </div>
    <p class="body-small">
      <slot />
    </p>
  </div>
</template>

<style scoped lang="scss">
.message {
  padding:  var(--spacing-s) var(--spacing-s) var(--spacing-ms);
  border-left: 2px solid var(--colour-light-warm-grey);

  &.is-type-danger {
    border-color: color(from var(--colour-danger) srgb r g b / 0.5);
    background-color: color(from var(--colour-danger) srgb r g b / 0.05);
  }
  &.is-type-warning {
    border-color: var(--colour-orange);
    background-color: color(from var(--colour-orange) srgb r g b / 0.1);
  }
  &.is-type-info {
    border-color: var(--colour-warm-grey);
    background-color: var(--colour-light-warm-grey);
  }
}
.message-title {
  margin-bottom: var(--spacing-xxs);
  display: flex;
  align-items: center;
  gap: var(--spacing-xxs);
}
p {
  color: var(--colour-mid-grey);

  &:last-child {
    margin-bottom: 0;
  }
}
</style>
